import { Path, Svg } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const HistoryLine = withDefaultIconProps({ height: 24, width: 2, color: '#999999' }, ({ color, ...rest }) => (
  <Svg {...rest} viewBox="0 0 2 24">
    <Path clipRule="evenodd" d="M0.5 24L0.5 0L1.5 0L1.5 24H0.5Z" fill={color} fillRule="evenodd" />
  </Svg>
));
